import React from 'react';
import Modal from 'react-modal';

const WhyAskModal = ({
  visible,
  onClose,
  children
}) => {
  return (
    <Modal
      isOpen={visible}
      ariaHideApp={false}
      onRequestClose={onClose}
      className="why_ask_popup"
    >
      <div className="why_ask_popup_container">
        <div className="popup_button" onClick={onClose}>
          <svg
            width="30"
            height="30"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M24.2567 10L25.8408 11.6L19.5838 17.9199L25.9995 24.4L24.4154 26L17.9997 19.5199L11.5841 26L10 24.4L16.4157 17.9199L10.1587 11.6L11.7427 10L17.9997 16.3199L24.2567 10Z"
              fill="#676767"
            />
            <circle cx="18" cy="18" r="17.529" stroke="#CCCCCC" strokeWidth="0.942021" />
          </svg>
        </div>
        <div className="why_ask_content">
          {children}
        </div>
      </div>
    </Modal>
  );
};

export default WhyAskModal;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/CustomerDesign/WhyAskModal.js